import styled from "styled-components";
import { device } from "../../utils/device";

export const Container = styled.div`
  display: grid;
  height: 100vh;
  width: 100vw;
  grid-template-columns: 40% 60%;
  overflow-x: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;


  @media ${device.mobilePortrait}, ${device.mobileLandscape}, ${device.tabletPortrait} {
    grid-template-columns: 1fr;
  }
`;

export const LeftView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
background: "white";
`;

export const RightView = styled.div`
  min-height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;

  @media ${device.mobilePortrait}, ${device.mobileLandscape}, ${device.tabletPortrait} {
    display: none;
  }
`;

export const MobileImage = styled.img`
  width: 100%;
  max-width: 550px;
  margin-bottom: 20px;
  margin-top: 20px;

  ${({ isTablet = false }) => isTablet && `
    position: absolute;
    max-width: 100%;
    top: 40px;
  `}
`;

export const IyugaImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

export const ContentView = styled.div`
  width: 28vw;
  min-width: 350px;
  padding: 40px 0px;
  max-width: 420px;

  @media ${device.mobilePortrait} {
    width: 80vw;
    min-width: 10px;
    margin-top: -60px;
  }

  @media ${device.mobileLandscape} {
    width: 70vw;
  }

  @media ${device.tabletPortrait} {
    width: 80vw;
  }
`;


export const LogoView = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media ${device.mobilePortrait}, ${device.mobileLandscape}, ${device.tabletPortrait} {
margin-top: 100px;
  }
`;

export const Logo = styled.img`
  width: 10vw;
  min-width: 120px;
`;

export const Overlay = styled.div`
position:absolute;
top: 0;
bottom: 0;
right: 0;
left: 0;
background-color: white;
opacity: 0.7;
`